export const cssBundleHref = "/build/css-bundle-3Z5U5CC5.css";